import Vue from 'vue'
import store from 'store'

Vue.directive('view', {
  bind(el, binding) {
    const view = binding.value.tag
    const setting = binding.value.setting
    el.addEventListener('click', () => {
      const payload = {
        view
      }

      if (setting) {
        payload.value = setting
      } else {
        payload.value = !store.getters.viewSettings[view]
      }
      store.dispatch('updateViewSettings', payload)
    })
  }
})
